import { FC, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import { ErrorComponent } from '.'

import { Page } from 'directFlow/types'
import BrokenStackedMarshform from 'assets/images/marshforms/broken-stacked.svg?react'

import { useDirectFlowPath } from 'src/router/direct-flow'
import { useQuoteHandler } from 'src/store/useQuoteHandler'
import { useEventTracking, useTracking } from 'utils'

type ErrorProps = {
  refresh?: boolean
}

export const ReferralCodeError: FC<ErrorProps> = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const track = useEventTracking()
  const directPath = useDirectFlowPath()

  const { updateQuoteGeneralInfo, getQuoteData } = useQuoteHandler()
  const { quoteId } = useParams<{ quoteId: string }>()

  const goBackToHomepage = () => {
    track('Error page - Go page to homepage')
    window.location.href = `https://www.marshmallow.com`
  }

  if (!quoteId) {
    throw new Error('ReferralCodeError component rendered without a quoteId')
  }

  const removeReferralCode = () => {
    track('Error page - Remove referral code')

    const currentQuoteGeneralInfo = getQuoteData(quoteId, 'generalInfo')

    const newQuoteGeneralInfo = { ...currentQuoteGeneralInfo, referralCode: undefined }

    updateQuoteGeneralInfo(quoteId, newQuoteGeneralInfo)

    return navigate(directPath(Page.POLICY_START_DATE))
  }

  useTracking('Error')

  useEffect(() => {
    const previousPage = JSON.stringify(location.state)
    track('Error redirected from' + previousPage)
  }, [location.state])

  return (
    <ErrorComponent
      description={`It looks like the referral link you used isn't working anymore. Please ask your friend to send you a new link from their Marshmallow app. If you're in a rush, you can always get a quote without a referral.`}
      primaryButtonLabel="Remove referral code"
      handlePrimaryButtonClick={removeReferralCode}
      primaryButtonIcon={null}
      secondaryButtonLabel="Back to homepage"
      handleSecondaryButtonClick={goBackToHomepage}
      secondaryButtonIcon={null}
      title="Oops! Your referral link has expired"
      marshform={<BrokenStackedMarshform />}
      hideIntercom={true}
    />
  )
}
